<template>
  <Container :mobile="mobile" :reverse="true">
    <img src="../../../assets/processDescription/step/4.svg" />
    <AdaptiveWidth tiny="100px" xlarge="150px" huge="150px" :height="height" />
    <div>
      <slot />
    </div>
  </Container>
</template>
<script>
import AdaptiveWidth from '../../../layout/AdaptiveWidth.vue';
import Container from './Container.vue';

export default {
  components: { Container, AdaptiveWidth },

  data() {
    return { mobile: window.innerWidth < 768, height: '50px' };
  },
  methods: {
    checkForMobile() {
      if (window.innerWidth < 768 && !this.mobile) {
        this.mobile = true;
        this.height = '50px';
        return;
      }
      if (window.innerWidth >= 768 && this.mobile) {
        this.mobile = false;
        this.height = '100%';
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkForMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkForMobile);
  },
};
</script>
<style scoped>
img {
  max-width: 150px;
  margin: 0 auto;
}
</style>
